(function ($, Drupal) {
  /**
   * Logo Grid
   */
   Drupal.behaviors.logoGrid = {
    attach: function () {
      $('.paragraph--type--logo-grid .logo-grid > *').height($('.paragraph--type--logo-grid .logo-grid > *:first-child').width() / 2);
      $(window).resize(function () {
        $('.paragraph--type--logo-grid .logo-grid > *').height($('.paragraph--type--logo-grid .logo-grid > *:first-child').width() / 2);
      });
    }
  };
})(jQuery, Drupal);